export interface IAppConfig {
  api: { url: string };
}

export const appConfig =
  process.env.NODE_ENV !== "development"
    ? ((window as any).appConfig as IAppConfig)
    : { api: { url: "https://plt-forms-api.deva.svc.bpcloud.dev" } };
